



























































































import {Vue, Component} from 'vue-property-decorator';
import { Mall } from 'supporter';
import {namespace} from 'vuex-class';
import { addDay, getToday } from '@/utils/dateUtils';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import TableTabMenu from '@/components/common/privacyAccessHistories/TableTabMenu.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import MallsTab from '@/components/common/MallsTab.vue';

const mallModule = namespace('mall');

@Component({
  components: { CompSelectBox, PageTitle, PeriodDateCalendar, MallsTab, TableTabMenu },
})
export default class ContentTop extends Vue {
  @mallModule.Getter('mallsSortedByCreationDate')
  private mallsSortedByCreationDate!: Mall[];

  private mallNo: number = null;
  private adminId: string = '';
  private startYmdt: string = addDay(new Date(), -7);
  private endYmdt: string = getToday();
  private PeriodOption = {
    name: 'startPeriod',
    periodTypes: ['td', 'ytd', '3d', '1w', '1m'],
    period: '1w',
  };
  private focusTableTabName = 'customTab';
  private menuList = [
    { name: 'customTab', title: this.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_CUSTOM_TAB') },
    { name: 'adminTab', title: this.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_ADMIN_TAB') },
  ];

  created() {
    this.setInitiateValue();
  }

  private get mallName() {
    return this.mallsSortedByCreationDate.find(({mallNo}) => this.mallNo === mallNo)?.mallName ?? '전체';
  }

  private setInitiateValue() {
    this.mallNo = undefined;// NOTE : 쇼핑몰 초기값 (전체)
    this.$emit('change', this.mallName);
  }

  private onChangeTableTab(name) {
    this.resetData();
    this.focusTableTabName = name;

    this.$emit('searchClick', 1);
  }
  private search() {
    this.$emit('searchClick', 1);
  }
  private resetData() {
    this.setInitiateValue();
    this.adminId = '';
    (this.$refs.dateCalendar as any).clickPeriod('1w');
  }
}
